import api from '@/api'
import { checkEstadosIguales } from '@/helpers/BotonesDespachoAcciones'
import { EMERGENCIA_CLASE, EMERGENCIA_ESTADO_TIPO, RECURSO_SECTOR_ESTADO_TIPO, RENOMBRES_INCENDIO } from '@/helpers/constants'
import { getLastEstadoRecurso } from '@/helpers/RecursoHelper'

const initialState = {
  estadosAccion: [],
  allBotones: [],
  canalesComunicacion: [],
}

const getters = {
  // Retorna la lista de estados
  estadosAccion: (state) => state.estadosAccion,
  botonesEstadosAccion: (state, localGetters, rootState, rootGetters) => (idTipoEstadoRecurso, idEmergencia, idEmergenciaEstado) => {

    const botones = state.estadosAccion.reduce((botonesDisponibles, boton) => {
      const mismoTipoEstado = boton.ID_RECURSO_SECTOR_ESTADO_TIPO === idTipoEstadoRecurso
      if (mismoTipoEstado) {
        // Si no tiene emergencia, estado desasignado
        if (!idEmergencia) botonesDisponibles.push(boton.RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON)

        const esControlado = idEmergenciaEstado === EMERGENCIA_ESTADO_TIPO.CONTROLADO
        const ordenEnIncidente = boton.RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON.ORDEN === RECURSO_SECTOR_ESTADO_TIPO.EN_INCIDENTE.ORDEN
        const ordenLiquidacion = boton.RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON.ORDEN === RECURSO_SECTOR_ESTADO_TIPO.LIQUIDACION.ORDEN

        // si la emergencia esta controlada, no podrá ser en incidente/incendio
        if (esControlado && !ordenEnIncidente) botonesDisponibles.push(boton.RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON)
        // si la emergencia no esta controlada, no podrá pasar a liquidación
        if (!esControlado && !ordenLiquidacion) botonesDisponibles.push(boton.RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON)
      }
      return botonesDisponibles
    }, [])
    return botones
  },
  allBotones: (state) => state.allBotones,
  getBotonesAsignacion: (state, getters) => (recursoSectorList, idEmergencia, emergenciaClase, idEmergenciaEstado) => {
    const botones = getters.allBotones

    if (!recursoSectorList?.length) return { botones, estadoInicial: null }

    const estadosActuales = recursoSectorList.map(recursoSector =>
      getLastEstadoRecurso(recursoSector.recurso.RECURSO_SECTOR_ESTADO)
    )

    // Se comprueba que se está despachando todos los recursos en el mismo estado
    const estadoReferencia = checkEstadosIguales(estadosActuales)

    if (!estadoReferencia) return { botones, estadoInicial: null }

    const asignables = getters.botonesEstadosAccion(
      estadoReferencia.ID_RECURSO_SECTOR_ESTADO_TIPO,
      idEmergencia,
      idEmergenciaEstado
    )

    const codigosAsignables = new Set(asignables.map(b => b.CODIGO))

    const botonesActualizados = botones.map(btn => ({
      ...btn,
      disabled: !codigosAsignables.has(btn.CODIGO)
    }))

    // Renombrado si es incendio  
    const botonesRenombrados =
      emergenciaClase === EMERGENCIA_CLASE.INCENDIO
        ? botonesActualizados.map(boton => ({
          ...boton,
          NOMBRE: RENOMBRES_INCENDIO[boton.NOMBRE] || boton.NOMBRE
        }))
        : botonesActualizados

    return { botones: botonesRenombrados, estadoInicial: estadoReferencia.NOMBRE }
  },

  getCanalesComunicacion: (state) => state.canalesComunicacion

}

const mutations = {
  // Mutación para guardar los estados en el state

  SET_ESTADOS_ACCION(state, estadosAccion) {
    state.estadosAccion = estadosAccion
  },
  SET_ALL_BOTONES(state, estadosAccion) {
    const botones = estadosAccion.map(estadoAction => estadoAction.RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON)
    state.allBotones = [
      ...new Map(botones.map(p => [
        p.ID_RECURSO_SECTOR_ESTADO_TIPO_ACCION_BOTON,
        { ...p, disabled: true }
      ])).values()
    ].sort((a, b) => a.ORDEN - b.ORDEN)
  },
  SET_CANALES_COMUNICACION(state, canalesComunicacion) {
    state.canalesComunicacion = canalesComunicacion
  }
}

const actions = {

  // Acción que obtiene los estados de acción desde la API
  async fetchEstadosAccion({ commit }) {
    try {
      const response = await api.recurso.getEstadosAcciones()
      if (response.status === 200) {
        commit('SET_ESTADOS_ACCION', response.data)
        commit('SET_ALL_BOTONES', response.data)
      }
    } catch (err) {
      console.error('[recursoSector] Error al obtener el listado de estados de acción: ', err)
      throw err
    }
  },

  async fetchCanalesComunicacion({ commit }) {
    try {
      const response = await api.emergencia.getCanalesComunicacion()
      commit('SET_CANALES_COMUNICACION', response.data)
    } catch (err) {
      console.error(err)
      throw err
    }
  },
}

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions
}
